import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateCreatedV1DataSchema } from "./estimate-review-shared";

const InsuranceRevisionEstimateCreatedDataSchema = z.discriminatedUnion("version", [EstimateCreatedV1DataSchema]);

export const InsuranceRevisionEstimateCreatedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_REVISION_ESTIMATE_CREATED),
  data: InsuranceRevisionEstimateCreatedDataSchema,
});

export type InsuranceRevisionEstimateCreatedTaskAttempt = z.infer<
  typeof InsuranceRevisionEstimateCreatedTaskAttemptSchema
>;
